import { configureStore } from '@reduxjs/toolkit'

import rootReducer from './reducers'

// const sagaMiddleware = createSagaMiddleware()

const store = configureStore({
  reducer: rootReducer,
  // middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(sagaMiddleware),
})


export default store